import { Lightbulb } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { EmptyState } from '@/components/ui/EmptyState';
import { ModuleTogglePanel } from '@/components/dashboard/ModuleTogglePanel';

/** cogs/ui_panel.py's DashboardConfig exposes only the module_suggestions
 * master toggle — the suggestion channel has no Bridge field yet. */
export function SuggestionsPage() {
  return (
    <div className="space-y-6">
      <ModuleTogglePanel module="suggestions" title="Suggestions" permissionNote="Manage Server permission required." />

      <Card>
        <CardHeader title="Suggestion channel" description="Where /suggest posts new suggestions — not connected to the Bridge yet." />
        <Input placeholder="#suggestions" className="max-w-xs" disabled />
      </Card>

      <Card>
        <CardHeader title="Review queue" description="Vote counts are already tracked by the bot — this reads them, doesn't add moderation status (v18 has none beyond raw votes today)." />
        <EmptyState icon={Lightbulb} title="No suggestions yet" />
      </Card>
    </div>
  );
}
